import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'Warehouse',
        caption: 'Warehouse',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true,
        allowEditing: false,
        allowSorting: true,
    },
    {
        dataField: 'Quantity',
        caption: 'Quantity',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        alignment: 'right'
    },
    {
        dataField: 'Bin',
        caption: 'Bin',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        allowSorting: true,
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.lg0,
        allowSorting: false,
    },
];
